<ng-container *ngIf="!!alarm" [ngSwitch]="mode">
  <qm-train-alarm-actions
    *ngSwitchCase="'train-button'"
    [tripNumber]="alarm.metadata.payload.tripNumber"
    (trainNumberClicked)="toggleTooltip($event.event, ttip)"
    #ttip="qmTooltip"
    [openPanelOnClick]="false"
    ngbTooltip="{{ 'Open alarm details' | translate }}"
    [qmTooltip]="tooltipContent"
    [darkBtn]="true">
  </qm-train-alarm-actions>
  <ng-container *ngSwitchCase="'icon'">
    <span
      (click)="toggleTooltip($event, ttip)"
      #ttip="qmTooltip"
      [qmTooltip]="tooltipContent">
      <ng-container *ngTemplateOutlet="technicalIcon"></ng-container>
  </span>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <span
      (click)="toggleTooltip($event, ttip)"
      #ttip="qmTooltip"
      [qmTooltip]="tooltipContent">
      <ng-container *ngTemplateOutlet="technicalIcon"></ng-container>
    </span>
  </ng-container>
</ng-container>

<ng-template #tooltipContent let-message="message">
  <div class="tooltip">
    <p *ngFor="let paragraph of message" class="paragraph">
      {{ paragraph }}
    </p>
  </div>
</ng-template>

<ng-template #technicalIcon>
  <i style="color: gray; margin-left:5px;" class="far fa-exclamation-triangle"></i>
</ng-template>
